module.exports = __webpack_public_path__ + "img/qr.e3edd977.png";